/**
 * Render a FILE / IMAGE / DOCUMENT / VIDEO EAV attribute value the same way
 * claim Evidence does: thumbnail rows with preview + download.
 *
 * Accepts the canonical `{ display, value: { uuid, file_name, file_url, ... } }`
 * envelope (or a list of them) that serializers produce via
 * ``format_file_value``. Bare UUID strings fall back to a single non-preview
 * row so we never flash the raw id as plain text.
 */

import { useMemo } from 'react'

import { EvidenceFileList } from '@/shared/components/evidence/evidence-file-list'
import { fileAttributeToEvidenceItems } from '@/shared/components/evidence/attribute-file-gallery-utils'

export function AttributeFileGallery({
  value,
  className,
}: {
  value: unknown
  className?: string
}) {
  const items = useMemo(() => fileAttributeToEvidenceItems(value), [value])
  if (items.length === 0) return null
  return (
    <EvidenceFileList
      items={items}
      className={
        className ??
        'w-full min-w-0 divide-y divide-[var(--rule)] overflow-hidden rounded-lg border border-[var(--rule)] bg-[var(--bg-card)]'
      }
    />
  )
}
